import React from 'react'
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table'

import DEFAULT_FILTERS, { useGetGlobalFilter } from 'core/table/filters'
import { ExtendedPagedTable } from 'core/table/components'
import { useBulkCheckOutColumns, getOperatorOptions } from '../hooks/useBulkCheckOutColumns'
import { EditableCheckOut } from '../types'
import { CUSTOM_FILTERS } from 'tracking/activity/utils'

const filterTypes = { ...DEFAULT_FILTERS, ...CUSTOM_FILTERS }

interface BulkCheckOutTableProps {
  checkOuts: EditableCheckOut[]
  onEdit: (row: EditableCheckOut) => void
}

export const BulkCheckOutTable = (props: BulkCheckOutTableProps) => {
  const { checkOuts, onEdit } = props

  const columns = useBulkCheckOutColumns(onEdit)
  const globalFilter = useGetGlobalFilter({
    columns,
    filterTypes,
    getOperatorOptions,
  })

  const table = useTable<EditableCheckOut>(
    {
      initialState: {
        // @ts-ignore
        globalFilter: '',
      },
      globalFilter,
      filterTypes,
      data: checkOuts,
      columns,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  )

  return (
    <ExtendedPagedTable
      table={table}
      columns={columns}
      getOperatorOptions={getOperatorOptions}
      compactView
      expandable={false}
      useGlobalSearch
      useFilters
      useColumnSelector={false}
    />
  )
}
